import React, { useEffect, useRef, useState } from 'react';
import './onvitestyle.css'
import featuredPlaceHoderA from '../../assets/wedding-onvite1.png';
import featuredPlaceHoderB from '../../assets/wedding-onvite2.png';
import featuredPlaceHoderC from '../../assets/wedding-onvite3.png';
import littleFlower from '../../assets/flower-snip.png';
import ceremonyEvent from '../../assets/wedding-info-1.png';
import receptionEvent from '../../assets/wedding-info-2.png';
import axios from 'axios';
import * as CONSTANTS from "../../CONSTANTS";
import { toast } from 'react-toastify';
import useInViewToggle from './useInViewToggle';
import { Parser } from 'html-to-react';
import SingleMessagesOnvite from './SingleMessagesOnvite';

function OnviteIntroduction({onviteEvent, rsvpList}) {

    const htmlParser                                                   = new Parser();
    const [featureList, setFeatureList]                                = useState([featuredPlaceHoderA, featuredPlaceHoderB, featuredPlaceHoderC]);
    const [placeholderFeatured, setPlaceHolderFeatured]                = useState(null);

    const [popupImage, setPopupImage]                                  = useState(null);

    const [sectionBlockHeadRef, inView]                                = useInViewToggle();

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * featureList.length);
        setPlaceHolderFeatured(featureList[randomIndex])
    },[])

    const getDayFromThisDate = (dateString) => {
    if (!dateString) return '';
        const date = new Date(dateString);
        // Use UTC methods to avoid timezone issues when parsing YYYY-MM-DD
        return String(date.getUTCDate()).padStart(2, '0');
    };

  /**
   * Extracts the abbreviated month name from a date string in "YYYY-MM-DD" format.
   * @param {string} dateString - The date string (e.g., "2025-11-29").
   * @returns {string} The abbreviated month name (e.g., "Nov").
   */
  const getMonthFromThisDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    // Use UTC methods to avoid timezone issues when parsing YYYY-MM-DD
    const options = { month: 'short', timeZone: 'UTC' };
    return date.toLocaleDateString('en-US', options);
  };

  /**
   * Extracts the full year from a date string in "YYYY-MM-DD" format.
   * @param {string} dateString - The date string (e.g., "2025-11-29").
   * @returns {string} The full year (e.g., "2025").
   */
   const getYearFromThisDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        // Use UTC methods to avoid timezone issues when parsing YYYY-MM-DD
        return String(date.getUTCFullYear());
    };

    const formatGoogleCalendarDate = (dateString) => {
        // Assuming dateString is in 'YYYY-MM-DD' format, e.g., '2025-08-19'
        // Google Calendar expects 'YYYYMMDDTHHMMSSZ' for timed events or 'YYYYMMDD' for all-day events.
        // For 'Save the Date', an all-day event is usually sufficient.
        // If you have specific times, you'll need to parse them and format accordingly.
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}${month}${day}`;
    };

    const saveDateToCalendar = () => {
        const eventDate = onviteEvent.onviteDetails?.mainEventDate;

        if (!eventDate) {
            console.warn("No mainEventDate found to save to calendar.");
            return;
        }

        const formattedDate = formatGoogleCalendarDate(eventDate);

        // Customize your event details
        const eventTitle = onviteEvent.onviteDetails?.mainEventTitle; // e.g., "Our Wedding Day!"
        const eventDescription = "Join us for a special celebration!"; // Add more details as needed
        const eventLocation = onviteEvent.onviteDetails?.mainAddress; // Optional

        const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE` +
                                `&text=${encodeURIComponent(eventTitle)}` +
                                `&dates=${formattedDate}/${formattedDate}` + // For an all-day event on a single day
                                `&details=${encodeURIComponent(eventDescription)}` +
                                `&location=${encodeURIComponent(eventLocation)}`;

        window.open(googleCalendarUrl, '_blank');
    };

    const [formRSVPData, setFormRSVPData] = useState({
        name: '',
        email: '',
        attending: 'yes',
        guests: 1,
        allergies: [],
        allergyInput: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormRSVPData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAllergyKeyDown = (e) => {
        if (e.key === 'Enter' && formRSVPData.allergyInput.trim()) {
        e.preventDefault();
            if (!formRSVPData.allergies.includes(formRSVPData.allergyInput.trim())) {
                setFormRSVPData((prev) => ({
                ...prev,
                allergies: [...prev.allergies, prev.allergyInput.trim()],
                allergyInput: ''
                }));
            }
        }
  };

  const removeAllergy = (item) => {
    setFormRSVPData((prev) => ({
      ...prev,
      allergies: prev.allergies.filter((a) => a !== item)
    }));
  };

  const handleSubmitRSVP = async (e) => {
    e.preventDefault();
    try{      
        const adjustedGuests = formRSVPData.attending === 'no' ? 0 : formRSVPData.guests;
        
         const postData = {
            ...formRSVPData,
            guests: adjustedGuests,
            onviteId: onviteEvent._id,
        };
        
        console.log('Submitted:', postData);

        const resData = await axios.post(CONSTANTS.API_URL + 'settings/rsvp/v1/create/onvite', postData);      

        toast.success(resData.data.message);
        setFormRSVPData({
            name: '',
            email: '',
            attending: 'yes',
            guests: 1,
            allergies: [],
            allergyInput: '',
            message: ''
        });

    }catch(err){
        console.log(err);
        toast.error("Something went wrong, please try again later.");
    }
  };

  function openAddressInGoogleMaps(address) {
        const encodedAddress = encodeURIComponent(address);
        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
        window.open(googleMapsUrl, '_blank'); // Opens in a new tab/window
  }
  
  
  return (
    <div className="introduction--layer">
      
        <div className="row row-unset">
            <div ref={sectionBlockHeadRef} 
                className={`col-md-6 heightfull creamyback2 animator-inview ${inView ? 'inview' : ''}`}>
                <div className="conent-information-introduction">
                    <div className="wedding-block-a text-center">
                        <h2 className="couple-title fade-1">{onviteEvent.spouseA} & {onviteEvent.spouseB}</h2>
                        <h3><span className="light-shade fade-2">{onviteEvent.status}</span> <span>{onviteEvent.onviteDetails?.mainEventTitle}</span></h3>
                        <div className="date-layer-phase">
                            <div className="item-peak item-day fade-3">
                                {getDayFromThisDate(onviteEvent.onviteDetails?.mainEventDate)}
                            </div>
                            <div className="item-peak item-month fade-4">
                                {getMonthFromThisDate(onviteEvent.onviteDetails?.mainEventDate)}
                            </div>
                            <div className="item-peak item-year fade-5">
                                 {getYearFromThisDate(onviteEvent.onviteDetails?.mainEventDate)}
                            </div>
                        </div>
                        <div className="text-center">
                            <button className="btn btn-inverted-main fade-2"
                                onClick={saveDateToCalendar}>
                                Save the Date on the callender
                            </button>
                           
                        </div>
                        <div className="text-center">
                             <img src={littleFlower} className="small-flower-onvite fade-1" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 heightfull"
                 >
                <div className="back-image-box">
                    <div className="back-introduction"
                        style={{
                        backgroundImage: `url(${onviteEvent.featureUrl && onviteEvent.featureUrl.trim() !== '' ? onviteEvent.featureUrl : placeholderFeatured})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                    }}>

                    </div>
                </div>    
            </div>
        </div>
        <div className="section-item relative-constrain">
            <div className="container">
                <h2 className="text-center mgtop30">About Invitation</h2>
                <div className="info-onvite-description">
                    {htmlParser.parse(onviteEvent.weddingOnviteMessage)}
                </div>
            </div>
        </div>
        <div className="section-item creamyback">
            <div className="container">               
                <div className="rsvp-box-outer">
                    <div className="rsvp-box-inner">
                        <div className="rsv-head">
                            <h2 className="text-center mgtop30">RSVP</h2>
                            <div className="sub-head">Are you attedning.</div>
                        </div>
                        <div className="rsvp-body p-4 shadow-sm">
                            <form className="" onSubmit={handleSubmitRSVP}>
                          
                                {/* Name */}
                                <div className="mb-3">
                                    <label className="form-label">Full Name*</label>
                                    <input 
                                        type="text" 
                                        name="name" 
                                        value={formRSVPData.name} onChange={handleChange} className="form-control"
                                        placeholder="Enter Full Name" required />
                                </div>

                                {/* Email */}
                                <div className="mb-3">
                                    <label className="form-label">Email*</label>
                                    <input type="email" name="email" value={formRSVPData.email} 
                                        onChange={handleChange} 
                                        className="form-control"
                                        placeholder="Enter Email Address"  required />
                                </div>

                                {/* Attending */}
                                <div className="mb-3">
                                    <label className="form-label me-3">Will you attend?</label><br/>
                                    <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="attending" value="yes" checked={formRSVPData.attending === 'yes'} onChange={handleChange} />
                                    <label className="form-check-label">Yes, I will be there</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="attending" value="no" checked={formRSVPData.attending === 'no'} onChange={handleChange} />
                                    <label className="form-check-label">Sorry, I can't come</label>
                                    </div>
                                </div>

                                {/* Guests */}
                                <div className="mb-3">
                                    <label className="form-label">Number of guests (including you)</label>
                                    <input 
                                        type="number" 
                                        name="guests" value={formRSVPData.guests} onChange={handleChange} 
                                        className="form-control" min="1" 
                                        disabled={formRSVPData.attending === 'no'}
                                        required />
                                </div>

                                {/* Allergies */}
                                <div className="mb-3">
                                    <label className="form-label">Any food allergies?</label>
                                    <input
                                        type="text"
                                        name="allergyInput"
                                        value={formRSVPData.allergyInput}
                                        onChange={handleChange}
                                        onKeyDown={handleAllergyKeyDown}
                                        className="form-control"
                                        placeholder="Press Enter to add"
                                    />
                                    <div className="mt-2">
                                    {formRSVPData.allergies.map((a, idx) => (
                                        <span key={idx} className="badge bg-warning text-dark me-2">
                                        {a} <button type="button" onClick={() => removeAllergy(a)} className="btn-close btn-close-white btn-sm ms-1" aria-label="Remove"></button>
                                        </span>
                                    ))}
                                    </div>
                                </div>

                                {/* Message */}
                                <div className="mb-3">
                                    <label className="form-label">Congratulations Message</label>
                                    <textarea 
                                        name="message" 
                                        value={formRSVPData.message} onChange={handleChange} 
                                        className="form-control" rows="4"
                                        placeholder="Share a message for the couple" />
                                </div>

                                <button type="submit" className="btn btn-main">Submit RSVP</button>
                                </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="section-item">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="info-event">
                            <div className="info-event-card">
                                <div className="image-box__event">
                                    <img src={ceremonyEvent} className="circling-hover" />
                                </div>
                                <div className="color-head-title">
                                    Main Ceremony
                                </div>
                                <div className="event-onvite-info-box">
                                    <p>{onviteEvent.onviteDetails.mainEventDate}</p>
                                    <p className="address-view">{onviteEvent.onviteDetails.mainAddress}</p>
                                    <p>Time:</p>
                                    <p>{onviteEvent.onviteDetails.mainStart} - {onviteEvent.onviteDetails.mainEnd}</p>
                                </div>
                                <div className="text-center">
                                     <button className="btn btn-main"
                                        onClick={() => openAddressInGoogleMaps(onviteEvent.onviteDetails.mainAddress)}>
                                        View Location
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                     <div className="col-md-6">
                        <div className="info-event">
                            <div className="info-event-card">
                                <div className="image-box__event">
                                    <img src={receptionEvent} className="circling-hover" />
                                </div>
                                <div className="color-head-title">
                                    Reception
                                </div>
                                <div className="event-onvite-info-box">
                                    <p>{onviteEvent.onviteDetails.receptionDate}</p>
                                    <p className="address-view">{onviteEvent.onviteDetails.receptionAddress}</p>
                                    <p>Time: </p>
                                    <p>{onviteEvent.onviteDetails.receptionStart} - {onviteEvent.onviteDetails.receptionEnd}</p>
                                </div>
                                 <div className="text-center">
                                     <button className="btn btn-main"
                                        onClick={() => openAddressInGoogleMaps(onviteEvent.onviteDetails.receptionAddress)}>
                                        View Location
                                    </button>
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {
            (onviteEvent.contactEmail != "" || onviteEvent.contactPhone) && (
                <div className="section-item over-close">
                    <div className="bg-contact"></div>
                    <div className="bg-contact bg2-contact"></div>
                    <div className="bg-contact bg3-contact"></div>
                    <div className="content-contact">
                        <h3>The Contact Person for any Queries</h3>
                        <p className="onvite-contact-persion"> 
                            <span>{onviteEvent.contactName}</span>
                            <span>{onviteEvent.contactEmail}</span>
                            <span>{onviteEvent.contactPhone}</span>
                        </p>
                    </div>
                </div>
            )
        }
        
        {
            rsvpList.length > 0 && (
                <SingleMessagesOnvite visibleMessages={rsvpList} />
            )
        }
        {
            onviteEvent.weddingOnviteCatalogue.length > 0 && (
                <div className="section-item">
                    <div className="gallery-Masonry">
                    {
                        onviteEvent.weddingOnviteCatalogue.map((imagery, index) => {
                            return <div className="layout-item" key={index}>
                                      <div className="img-wrap phCount">
                                            <img 
                                                src={imagery.url} 
                                                alt={"Onvite event - " + onviteEvent.spouseA + " " + onviteEvent.spouseB} 
                                                class="single-image"
                                                onClick={() => setPopupImage(imagery.url)}
                                                />
                                      </div>
                                   </div>
                        })
                    }
                   </div>
                   {
                    popupImage && (
                            <div className="popup-overlay" onClick={() => setPopupImage(null)}>
                                <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                                    <img src={popupImage} alt="Event Dripp" />
                                    <button className="close-button" onClick={() => setPopupImage(null)}>×</button>
                                </div>
                            </div>
                        )
                    }
                </div>
            )
        }
    </div>
  )
}

export default OnviteIntroduction